<!--
  控制台员工管理使用
-->
<template>
  <div class="dash-employee-item">
    <div class="employee-info">
      <img
        :src="employee.headImage || defImage('head')"
        class="avatar"
      />
      <div class="basic-info">
        <div class="basic-info-line1">
          <span class="name">{{ employee.name }}</span>
          <span class="position">{{ employee.post }}</span>
          <!-- <span class="role">普通员工</span> -->
        </div>
        <div class="tel">{{ employee.mobile }}</div>
        <div class="email">{{ employee.email }}</div>
      </div>
    </div>

    <div class="footer flex-end font-size-14">
      <div
        class="pointer"
        @click="callback({ type: 'edit', data: { employee } })"
      >
        <span
          class="iconfont iconact_jiaobiaobianji theme-icon-primary-color"
        ></span>
        <span>{{ $t('editor') }}</span>
      </div>
      <div
        class="pointer"
        @click="callback({ type: 'del', data: { employee } })"
      >
        <span class="iconfont iconqingkong- theme-icon-primary-color"></span>
        <span>{{ $t('del') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'dash-employee',
  props: {
    employee: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    callback(payload) {
      this.$emit('callback', payload)
    }
  }
}
</script>

<style lang="stylus">
.dash-employee-item
  width 480px
  position relative
  box-shadow 0px 2px 6px 0px $box-shadow2
  border-radius 4px
  margin 0 24px 24px 0
  transition all .3s
  background: $color-white

  &:hover
    box-shadow 0 6px 20px 5px $box-shadow1, 0 16px 24px 2px $box-shadow2

  .employee-info
    display flex
    height 100px
    align-items center
    padding-top 15px
    .basic-info
      height 70px
    .basic-info-line1
      display flex
      align-items center
    span
      margin-right 10px
      display inline-block
    .name
      font-size 16px
      font-weight bold
      color $color-black-65
    .position
      font-size 14px
      color $color-black-45
    .role
      padding 2px 6px
      font-size 12px
      color $color-main
      border 1px solid $color-main
    .tel
      color $color-black-65
      margin: 7px 0
    .email
      color $color-black-65

  .avatar
    width 60px
    height 60px
    border-radius 50%
    margin 0 16px
    object-fit cover

  .footer
    padding-bottom: 12px;
    padding-right 12px
</style>
